export default {
  // Endpoints
  loginEndpoint: 'lk/signin',
  registerEndpoint: 'lk/signup',
  refreshEndpoint: 'lk/refresh-token',
  forgotEndpoint: 'lk/forgot-password',
  resetEndpoint: 'lk/change-password',
  logoutEndpoint: 'lk/logout',
  verifyLoginEndpoint: 'lk/change-password',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
  storageUserDataKeyName: 'userData',
}
